<template>
  <div class="page">
    <Frame>
      <template v-slot:body>
        <div class="body">
          <van-field
            v-model="remark"
            rows="5"
            autosize
            label=""
            type="textarea"
            maxlength="200"
            placeholder="请输入拒绝理由（必填）"
            show-word-limit
          />
        </div>
      </template>
      <template v-slot:footer>
        <div class="footer">
          <div class="btn submit" @click="approveResultSave">确定</div>
        </div>
      </template>
    </Frame>
  </div>
</template>

<script>
import Frame from "@/components/frame.vue";
import { Toast } from "vant";
import { ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
export default {
  name: "auditRefuse",
  components: {
    Frame,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    console.log(route)

    const { applyId, approveCode, bizType } = route.query || {};
    const remark = ref("");

    const approveResult = (params) => store.dispatch("repair/approveResult", params);
    const approveResultSave = async () => {
      if (!applyId) {
        Toast.fail("记录编号缺失！");
        return;
      }
      if (!bizType) {
        Toast.fail("bizType类型缺失！");
        return;
      }
      if (!remark.value) {
        Toast.fail("请输入拒绝理由！");
        return;
      }
      let params = {
        applyId,
        approveCode,
        approveResult: false,
        bizType,
        dealMsg: remark.value,
      };
      let r = await approveResult(params);
      let { success, message } = r;
      if (success) {
        Toast.success('拒绝成功');
        router.go(-1);
      } else {
        Toast.fail(message);
      }
    };

    const cancleEvt = () => {
      router.go(-1);
    };
    return {
      remark,
      approveResultSave,
      cancleEvt,
    };
  },
};
</script>

<style lang="less" scoped>
.page{
  height: 100vh;
}
.footer {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 15px;
  background-color: #fff;
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 36px;
    font-size: 15px;
    font-weight: 400;
    border-radius: 18px;
    border: 1px solid #4174fd;
    &.cancle {
      color: #4275FD;
      background-color: #ffffff;
    }
    &.submit {
      color: #fff;
      background-color: #4174fd;
    }
  }
}
</style>
